import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
export const requestExistingAccounts = () => noPortalApiClient.get('acquisition/v1/accounts/cross-hublet', {
  query: {
    includePins: false,
    includeStats: true
  }
});